import { render, staticRenderFns } from "./ContactBox.vue?vue&type=template&id=1adaac11&scoped=true"
import script from "./ContactBox.vue?vue&type=script&lang=js"
export * from "./ContactBox.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1adaac11",
  null
  
)

export default component.exports